import styled from 'styled-components';
import { RalewayFont } from 'constants/fonts';
import { TABLET_WIDTH } from 'constants/breakPoints';
import { white } from 'constants/colors';

export const CallHall = styled.div`
  .content_call {
    width: calc(100% - 6rem);
    margin: 0 auto;

    @media (max-width: ${TABLET_WIDTH}px) {
      width: 100%;
    }
  }
  .callInfo {
    height: 15rem;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    .opacity {
      position: absolute;
      z-index: 1;
      background: rgb(255,255,255);
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.5) 100%);
      width: 100%;
      height: 100%;
    }

    .back {
      height: 70%;
      width: 4%;
      display: flex;
      justify-content: flex-end;
      z-index: 2;
      i {
        font-size: 2rem;
        cursor: pointer;
        color: white;
      }
    }
    img {
      height: 80%;
      width: 20%;
      z-index: 2;
    }
    .data {
      height: 70%;
      width: 40%;
      color: white;
      z-index: 2;
      .name {
        font-size: 1.8rem;
        font-weight: 800;
        margin: 1rem;
      }
      .live_event {
        font-size: 1.4rem;
        margin: 1rem;
      }
      .starting {
        font-size: 1.4rem;
        margin: 1rem;
        display: flex;
        align-items: center;
      }
    }
    .buttons {
      height: 80%;
      width: 31%;
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      z-index: 2;
      .main_button {
        width: 10rem;
        font-size: 1.2rem;
        background: #2680EB;
        color: white;
        padding: 1rem;
        margin: 1rem;
        border-radius: 2rem;
        text-transform: uppercase;
      }
      .sec_button {
        width: 10rem;
        font-size: 1.2rem;
        background: white;
        color: #2680EB;
        padding: 1rem;
        margin: 1rem;
        border-radius: 2rem;
        text-transform: uppercase;
      }
    }
    @media (max-width: ${TABLET_WIDTH}px) {
      height: 12rem;
      position: relative;
      .back {
        display: none;
      }
      img {
        height: 80%;
        width: 30%;
      }
      .data {
        height: 70%;
        width: 70%;
        .name {
          font-size: 1.2rem;
        }
        .live_event {
          font-size: 1rem;
        }
        .starting {
          font-size: 1rem;
        }
      }
      .buttons {
        height: 80%;
        width: 50%;
        display: flex;
        flex-direction: row;
        position: absolute;
        bottom: 0;
        right: 0;
        .main_button {
          width: 7rem;
          font-size: 0.9rem;
          font-weight: bold;
          background: #2680EB;
          color: white;
          padding: 0.5rem;
          margin: 1rem;
          border-radius: 2rem;
          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
          text-transform: none;
        }
        .sec_button {
          width: 7rem;
          font-size: 0.9rem;
          font-weight: bold;
          border: none;
          background: white;
          color: #2680EB;
          padding: 0.5rem;
          margin: 1rem;
          border-radius: 2rem;
          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
          text-transform: none;
        }
      }
    }
  }
  .secondary {
    border-radius: 20px;
    font-size: 15px;
    border: 0px;
    color: #1976d2;
    background-color: #fff;
    -webkit-box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    padding: 10px 20px;
    letter-spacing: 1px;
  }

  .add_to_calendar {
    font-family: ${RalewayFont.regularFamily}
    font-size: 1.3rem;
    font-weight: ${RalewayFont.boldWeight}
    color: ${white}
    justify-content: center;
    margin-bottom: 15px;
    text-shadow: 1px 3px 3px rgb(0 0 0);
    cursor: pointer;
  }

  .addToCalendarWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 25rem;
  }

  > .header {
    height: 20rem;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;

    > .content {
      padding: 3rem;
      position: relative;
      z-index: 10;
      > .name {
        color: #fff;
        font-size: 2.7rem;

        @media (max-width: ${TABLET_WIDTH}px) {
          font-size: 1.8rem;
        }

        img {
          margin-right: 0.5rem;

          &.call_icon {
            width: 2rem;
          }
        }
      }

      > .time_limit {
        color: #fff;
        font-size: 1.3rem;
        margin: 1rem 0 0.5rem;
        @media (max-width: ${TABLET_WIDTH}px) {
          font-size: 1.1rem;
        }
      }

      > .starting_in {
        display: inline-block;
        color: #fff;
        font-size: 1.3rem;
        margin-right: 0.5rem;
      }

      > .countdown {
        display: inline-block;
        font-size: 1.3rem;
        margin-top: 0.5rem;
        @media (max-width: ${TABLET_WIDTH}px) {
          font-size: 1.1rem;
        }
      }
    }

    > .opacity {
      position: absolute;
      z-index: 1;
      background: rgb(255,255,255);
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.5) 100%);
      width: 100%;
      height: 100%;
    }

    > .buttons {
      position: absolute;
      z-index: 10;
      width: 100%;
      bottom: 2rem;
      text-align: center;
      button {
        min-width: 10rem;
      }
    }
  }

  .tabs {
    background-color: #fff;
  }

  .name_section {
    color: #333;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    .number {
      font-weight: bold;
      color: black;
      margin-right: 0.5rem;
    }
    .invite_placeholder{
      font-size: 1.1rem;
      margin-left: 0.8rem;
      color: #2680EB;
    }
  }
`;

export const Description = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  min-height: 5rem;
  margin-top: 1rem;
  color: #707070;
  .desc {
    width: 90%;
    line-break: anywhere;
    line-height: 1.8rem;
  }
`;

export const AgendaWrapper = styled.div`
  width: 90%;
  margin: 0 auto 4rem;
`;

export const Tags = styled.div`
  min-height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  .filters_tags {
    width: 90%;
    display: flex;
    overflow: scroll;
  }
`;

export const Users = styled.div`
  min-height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  .users {
    width: 90%;
  }
  .scroll_users {
    height: 15rem;
    display: flex;
  }
`;

export const Content = styled.div`
  min-height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  .content_list {
    width: 90%;
  }
  .name_section {
    color: #333;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    .number {
      font-weight: bold;
      color: black;
      margin-right: 0.5rem;
    }
    .invite_placeholder{
      font-size: 1.1rem;
      margin-left: 0.8rem;
      color: #2680EB;
    }
  }
`;

export const Tables = styled.div`
  min-height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 3rem;
  .tables {
    width: 90%;
  }
  .tables_in {
    overflow-x: scroll;
    cursor: pointer;
  }
  .name_section {
    color: #333;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    .number {
      font-weight: bold;
      color: black;
      margin-right: 0.5rem;
    }
    .invite_placeholder{
      font-size: 1.1rem;
      margin-left: 0.8rem;
      color: #2680EB;
    }
  }
`;

export const Affiliations = styled.div`
  min-height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  .tables {
    width: 90%;
  }
  .name_section {
    color: #333;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    .number {
      font-weight: bold;
      color: black;
      margin-right: 0.5rem;
    }
    .invite_placeholder{
      font-size: 1.1rem;
      margin-left: 0.8rem;
      color: #2680EB;
    }
  }
`;

export const CalendarWrapper = styled.div`
  height: 20rem;
  width: 90%;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  border-radius: 3rem;
  .close_button {
    width: 95%;
    height: 15%;
    font-size: 2rem;
    margin-top: 2rem;
    i {
      float: right;
      cursor: pointer;
      color: #707070;
    }
  }
  .title {
    text-align: center;
    height: 10%;
    font-size: 1.3rem;
    color: #2680EB;
  }

  .icons {
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    .icon {
      height: 50%;
      width: 40%;
      text-align: center;
      font-size: 1.3rem;
      cursor: pointer;
    }
    .icon_name {
      margin-top: 1rem;
      cursor: pointer;
    }
    img {
      height: 100%;
      cursor: pointer;
    }
  }
`;

export const TabsSection = styled.div`
  .tabs {
    padding-top: 1rem;
    background-color: #fff;
  }

  .tabs::-webkit-scrollbar {
    display: none;
  }

  .tabs {
  white-space: nowrap;
  display: grid;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &.flex {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 7vh;
  }

  .tab {
    text-align: center;
    padding: 1.5rem 1rem;
    color: #767676;
    font-size: 1.4rem;
    cursor: pointer;
    min-width: 11rem;

    &.selected {
      border-bottom: 2px solid #000;
      color: #000;
    }
  }

  &.gray {
    background-color: #D9D9D9;

    .tab {
      color: #000;
      &.selected {
        border-bottom: 2px solid #000;
      }
    }
  }
}
`;

export const SliderTables = styled.div`
  display: flex;
  align-items: center;
  overflow: auto;
`;

export const AddButton = styled.div`
  background: #2680EB;
  border-radius: 100%;
  font-size: 4rem;
  color: white;
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  padding: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CreateTable = styled.div`
  position: fixed;
  bottom: 4rem;
  right: 4rem;
  z-index: 10000000000000;

  @media (max-width: ${TABLET_WIDTH}px) {
    bottom: 8rem;
    right: 2rem;
  }
`;



// WEBPACK FOOTER //
// ./src/routes/Call/components/styles.js